import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./Reveal";
import { useLang } from "@/lib/i18n";

export const Faq = () => {
  const { copy } = useLang();
  return (
    <section id="faq" data-testid="faq-section" className="py-16 md:py-24 px-6 md:px-12 max-w-[1600px] mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <p className="overline-label mb-6">{copy.faq.overline}</p>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05]">
            {copy.faq.titleA}<br />
            <span className="italic text-gold-dark">{copy.faq.titleItalic}</span>
          </h2>
          <p className="mt-6 text-sm font-light text-plum/60 leading-relaxed max-w-sm">
            {copy.faq.sub}
          </p>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {copy.faq.items.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b hairline" data-testid={`faq-item-${i}`}>
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-7 text-start font-serif text-lg md:text-2xl text-plum hover:text-gold-dark hover:no-underline transition-colors duration-300 [&>svg]:text-gold-dark"
                >
                  <span className="flex gap-6 items-baseline">
                    <span className="text-xs font-sans tracking-[0.3em] text-plum/40">{String(i + 1).padStart(2, "0")}</span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="pb-8 ps-10 md:ps-12 text-sm md:text-base font-light leading-relaxed text-plum/70 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
